import React from "react";
import { MapPin, Plane, Compass } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { translations } from "../i18n/translations";
import { images } from "../data/images";

const icons = [MapPin, Plane, Compass];

export default function Location() {
  const { t } = useLanguage();
  const tx = translations.location;

  return (
    <section id="ubicacion" className="relative">
      <div className="relative h-[70vh] min-h-[500px] overflow-hidden">
        <img
          src={images.playaTodosSantos}
          alt="Todos Santos beach"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/55" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-[1280px] mx-auto px-6 lg:px-12 w-full pb-16 lg:pb-24">
            <div className="flex items-center gap-4 mb-8">
              <div className="h-[1px] w-10 bg-white/70" />
              <span
                className="text-white/85 text-[11px] tracking-[0.45em] uppercase"
                style={{ fontFamily: "'Jost', sans-serif" }}
              >
                {t(tx.eyebrow)}
              </span>
            </div>
            <h2
              className="text-white text-[36px] sm:text-[52px] lg:text-[68px] leading-[1.08]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
            >
              {t(tx.title1)}
              <br />
              <em className="italic">{t(tx.title2)}</em>
            </h2>
          </div>
        </div>
      </div>

      <div className="bg-[#F5F0E8] py-24 lg:py-32">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
            <div className="lg:col-span-7">
              <p
                className="text-[#3a3a36] text-[18px] lg:text-[22px] leading-[1.65] mb-8"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
              >
                {t(tx.intro)}
              </p>
              <p
                className="text-[#3a3a36] text-[15px] lg:text-[16px] leading-[1.85]"
                style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
              >
                {t(tx.text)}
              </p>
            </div>
            <div className="lg:col-span-5 space-y-7">
              {tx.cards.map((card, i) => {
                const Icon = icons[i] || MapPin;
                return (
                  <div
                    key={i}
                    className="flex gap-5 pb-7 border-b border-[#E0DACE] last:border-0"
                  >
                    <div className="flex-shrink-0 w-12 h-12 rounded-full border border-[#9C8456]/40 flex items-center justify-center">
                      <Icon className="w-5 h-5 text-[#9C8456]" strokeWidth={1.3} />
                    </div>
                    <div>
                      <h4
                        className="text-[#2A2A28] text-[20px] mb-1"
                        style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
                      >
                        {t(card.title)}
                      </h4>
                      <p
                        className="text-[#6B6760] text-[14px] leading-[1.6]"
                        style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
                      >
                        {t(card.desc)}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="mt-16 lg:mt-20 overflow-hidden border border-[#E0DACE]">
            <iframe
              title="NACUII location"
              src="https://www.google.com/maps?q=23.4733341,-110.2570382&hl=en&z=17&output=embed"
              width="100%"
              height="500"
              style={{ border: 0, filter: "grayscale(0.3) contrast(0.95)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
